"use client";

import { useLocale } from "@i18n/next";
import {
  KEY_COMMUNITIES_ADMIN_USERS_BASE,
  keyCommunitiesAdminCommunities,
  keyCommunitiesAdminCommunity,
  keyMe,
  useQueryClient,
} from "@packages/sdk";

export const useInvalidateCommunityQueries = ({ id }: { id: number }) => {
  const locale = useLocale();
  const queryClient = useQueryClient();

  return async () => {
    await Promise.all([
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey
            .flat()
            .some((keyPart) => keyPart === KEY_COMMUNITIES_ADMIN_USERS_BASE),
      }),

      /** Legacy invalidations */
      queryClient.invalidateQueries({
        queryKey: [keyCommunitiesAdminCommunity({ id }), locale],
      }),
      queryClient.invalidateQueries({
        queryKey: [keyCommunitiesAdminCommunities(), locale],
      }),
      queryClient.invalidateQueries({ queryKey: [keyMe(), locale] }),
    ]);
  };
};
